<template>
  <generic-in-app-screen>
    <b-container class="flex-grow-1 d-flex flex-column">
      <h1 class="my-5">
        <b>{{ $t('current_projects_list') }}</b>
      </h1>

      <lazy-list-display-y
        :nb="projects.length"
        :block_rounding="10"
        class="flex-grow-1 synaplus-cosmo-scroll-higher-720 synaplus-cosmo-h-720"
      >
        <template #default="{nby, height}">
          <project-description
            :key="nby"
            :value="projects[nby]"
            :style="height"
          ></project-description>
        </template>
      </lazy-list-display-y>

      <b-card :header="$t('new_project')" class="mt-4">
        <b-row>
          <b-col cols="12" md="9">
            <b-form-group>
              <label>
                <b> {{ $t('name') }} </b>
              </label>
              <b-form-input v-model="name" type="text" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="3">
            <b-form-group>
              <label>
                <b> {{ $t('default_workflow') }} </b>
              </label>
              <b-form-select
                v-model="populate_selected"
                :options="populate_options"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12" offset="0" md="3" offset-md="9">
            <b-button
              :disabled="add_project_button_is_disabled"
              variant="primary"
              block
              @click="add_project"
              >{{ $t('add') }}</b-button
            >
          </b-col>
        </b-row>
      </b-card>
    </b-container>
  </generic-in-app-screen>
</template>

<style scoped></style>

<i18n>
{
  "en": {
    "current_projects_list": "Current projects list",
    "new_project": "New project",
    "default_workflow": "Default workflow:",
    "name": "Name:",
    "add": "Add",
    "empty_project": "Empty",
    "simple_kaggle_project": "Simple",
    "agregation_kaggle_project": "Simple with aggregation"
  },
  "fr": {
    "current_projects_list": "Liste des projets en cours",
    "new_project": "Nouveau projet",
    "default_workflow": "Workflow par défaut :",
    "name": "Nom :",
    "add": "Ajouter",
    "empty_project": "Vide",
    "simple_kaggle_project": "Simple",
    "agregation_kaggle_project": "Simple avec agrégation"
  }
}
</i18n>

<script>
import _ from 'lodash'

import { mapGetters, mapState } from 'vuex'

import { create_project } from '@/api/subscriptions.js'
import cities from '@/components/cities.js'

import { subscription_mixin } from '@/components/mixin.js'
import ProjectDescription from './project_description.vue'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'

import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

// *****************************************************************************

export default {
  name: 'ProjectsList',
  components: {
    LazyListDisplayY,
    ProjectDescription,
    GenericInAppScreen,
  },
  mixins: [subscription_mixin],
  data() {
    return {
      name: cities[Math.floor(Math.random() * cities.length)],
      populate_selected: 'empty',
      populate_options: [
        { value: 'empty', text: this.$t('empty_project') },
        { value: 'simple_kaggle', text: this.$t('simple_kaggle_project') },
        {
          value: 'aggregation_kaggle',
          text: this.$t('agregation_kaggle_project'),
        },
      ],
      add_project_button_is_disabled: false,
    }
  },
  computed: {
    projects() {
      if (!this.automl_projects_undeleted_object) return
      let res = _.map(
        this.automl_projects_undeleted_object.lists,
        v => this.automl_projects_undeleted_object.projects[v]
      )
      return res
    },

    ...mapGetters(['automl_projects_undeleted_object']),
    ...mapState(['authenticated_user_id']),
  },
  beforeMount() {
    // N.B : Do we need it to still be in beforeMount ?
    this.fetch_collections(['projects', 'users', 'project_rights'])
  },
  methods: {
    async add_project(event) {
      this.add_project_button_is_disabled = true
      this.$store.commit('use_default_workflow', this.populate_selected)

      let proj = await create_project({
        creator: 'automl_project',
        members: {
          name: this.name,
          creator_user_id: this.authenticated_user_id,
        },
      })
      let path = `/projects/${proj.uid}/workflow`
      this.$router.push(path)
    },
  },
}
</script>
